import React, { useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, reportDWH } from '../saleJetBlockSlice';
import PavingFee from '../Partials/PavingFee/PavingFee';
import { getCustomerAddresses, createSaleAsync } from '../saleBlockAsyncThunk';

const PavingFeePage = (props) => {

  useEffect(() => {
    props.reportDWH({ actionType: 'Deployment Fee', status: 'Ongoing', messageText: 'Deployment Fee Page Displayed' });
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      {/* <h1 className='sale-title-big'> שמחים לעדכן שניתן לבצע פריסת סיבים בכתובת: ברוש 3 נתניה </h1> */}
      <h1 className='sale-title-big'> קבענו ליום {props.selectedTechnicianTimeDisplay} </h1>
      <h2 className='sale-title-small'> דמי הפריסה בדירתך הינם ₪{displayPrice(props.saleCatalog.pavingFee.price)}</h2>
    </div>
  );

  let currentPageView = <PavingFee pavingFeePopupText={props.pavingFeePopupText} pavingFeeTooltipText={props.pavingFeeTooltipText} onOpenPopup={handleOpenPopup} />;

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinue() {
    switch (props.saleType) {
      case 'tv':
      case 'app':
        if (props.flowType == 'existsCustomer') {
          //----------------------------------
          const hasTv = props.userAddressForUpgradePage.selectedAddress?.products?.find(x => x.type.toLowerCase() == 'tv');
          let isDisplayEmailPage = ((props.collectEmailOnProcess || props.saleType == 'tv' || props.saleType == 'app' || props.saleType == 'triple') && !hasTv);
          if (isDisplayEmailPage) {
            props.goToPage('emailPage');
          }
          else {
            props.createSaleAsync();
          }
          //----------------------------------
        } else {
          props.goToPage('personalInfoPage');
        }
        break;
      case 'cellular':
        break;
      case 'internet':
      case 'triple':
        if (props.saleType === 'internet') {
          props.goToPage('paymentPage');
          break;
        }
        if (props.flowType == 'existsCustomer') {
          props.getCustomerAddresses();
        } else {
          props.goToPage('personalInfoPage');
        }
        break;
    }
  }


  function handleOpenPopup() {
    props.reportDWH({ actionType: 'Deployment Fee', status: 'Ongoing', messageText: 'Deployment Fee Info Clicked' });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function displayPrice(price) {
    if (typeof price === 'number') {
      return parseFloat(price.toFixed(2));
    }
    else {
      return parseFloat(parseFloat(price).toFixed(2));
    }
  };

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    orderType: state.saleJetBlock.orderType,
    offerName: state.saleJetBlock.offerName,
    pavingFeePopupText: state.saleJetBlock.saleBlockData.pavingFeePopupText,
    pavingFeeTooltipText: state.saleJetBlock.saleBlockData.pavingFeeTooltipText,
    selectedTechnicianTimeDisplay: state.saleJetBlock.technician.selectedTechnicianTimeDisplay,
    saleCatalog: state.saleJetBlock.saleCatalog,
    collectEmailOnProcess: state.saleJetBlock.checkUserResponse.collectEmailOnProcess,
    userAddressForUpgradePage: state.saleJetBlock.userAddressForUpgradePage,
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  getCustomerAddresses,
  createSaleAsync,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(PavingFeePage);